import { createReducer } from 'typesafe-actions';
import api from '../../services/api';
import {
  generateToken,
  rehydrate,
  setCPF,
  validateToken,
  purge,
  page,
  setAcceptedTerms,
  getUserConfirmedData,
  setUserConfirmedData,
  setEmailConfirmado,
  setTelefoneConfirmado,
  setEnderecoConfirmado,
  updatePercentage,
  generateNewTelephone,
  validateNewTelephone,
  cleanTelephoneCredential,
  tokenSentTimeAction,
} from './actions';

const INITIAL_STATE: AuthState = {
  signed: false,
  cpf: '',
  status: '',
  token: '',
  user: undefined,
  userConfirmedData: undefined,
  page: 'contrato',
  updateProfile: '',
  percentage: 0,
  telephoneAccept: false,
  telTokenError: false,
  tokenSentTime: undefined,
};

const authReducer = createReducer(INITIAL_STATE)
  .handleAction(purge, (state, action) => {
    window.localStorage.removeItem('acceptedCookies');
    api.setToken('');
    return INITIAL_STATE;
  })
  .handleAction(setCPF, (state, action) => ({ ...state, cpf: action.payload }))
  .handleAction(rehydrate, (state, action) => {
    api.setToken(action.payload?.auth?.token || '');
    return { ...state, ...action.payload?.auth };
  })
  .handleAction(generateToken.success, (state) => ({
    ...state,
    status: 'ok',
  }))
  .handleAction(generateToken.failure, (state, action) => ({
    ...state,
    status: action.payload,
  }))
  .handleAction(validateToken.request, (state, action) => ({
    ...state,
    loading: true,
  }))
  .handleAction(validateToken.success, (state, action) => {
    return {
      ...state,
      token: action.payload.token,
      user: action.payload.user,
      signed: true,
      loading: false,
    };
  })
  .handleAction(validateToken.failure, (state, action) => {
    window.localStorage.removeItem('acceptedCookies');

    return {
      ...state,
      token: undefined,
      user: undefined,
      signed: false,
      status: action.payload,
      loading: false,
    };
  })
  .handleAction(page, (state, action) => ({
    ...state,
    page: action.payload,
  }))
  .handleAction(setAcceptedTerms, (state, action) => ({
    ...state,
    user: {
      ...(state.user as ValidatedUser),
      acceptedTerms: action.payload,
    },
  }))
  .handleAction(getUserConfirmedData.success, (state, action) => ({
    ...state,
    userConfirmedData: action.payload,
  }))
  .handleAction(getUserConfirmedData.failure, (state) => ({
    ...state,
    userConfirmedData: undefined,
  }))
  .handleAction(setUserConfirmedData.success, (state, action) => ({
    ...state,
    updateProfile: action.payload,
  }))
  .handleAction(setUserConfirmedData.failure, (state, action) => ({
    ...state,
    updateProfile: action.payload,
  }))
  .handleAction(setEmailConfirmado.success, (state, action) => ({
    ...state,
    updateProfile: action.payload,
  }))
  .handleAction(setEmailConfirmado.failure, (state, action) => ({
    ...state,
    updateProfile: action.payload,
  }))
  .handleAction(setTelefoneConfirmado.success, (state, action) => ({
    ...state,
    updateProfile: action.payload,
  }))
  .handleAction(setTelefoneConfirmado.failure, (state, action) => ({
    ...state,
    updateProfile: action.payload,
  }))
  .handleAction(setEnderecoConfirmado.success, (state, action) => ({
    ...state,
    updateProfile: action.payload,
  }))
  .handleAction(setEnderecoConfirmado.failure, (state, action) => ({
    ...state,
    updateProfile: action.payload,
  }))
  .handleAction(updatePercentage, (state, action) => ({
    ...state,
    percentage: action.payload,
  }))
  .handleAction(validateNewTelephone.success, (state, action) => ({
    ...state,
    telephoneAccept: action.payload,
    telTokenError: false,
  }))
  .handleAction(generateNewTelephone.success, (state) => ({
    ...state,
    telTokenError: false,
    telephoneAccept: false,
  }))
  .handleAction(validateNewTelephone.failure, (state, action) => ({
    ...state,
    telTokenError: !action.payload,
  }))
  .handleAction(cleanTelephoneCredential, (state) => ({
    ...state,
    telTokenError: false,
    telephoneAccept: false,
  }))
  .handleAction(tokenSentTimeAction, (state, action) => ({
    ...state,
    tokenSentTime: action.payload,
  }));
export default authReducer;
